import { getAmazonLpClientdId } from '../components/PartnerBanner/AmazonLpUtils';
import { checkIsAmazonLP } from './LandingPageUtils';

// Constants
const PLATFORM = 'web';
const IDP_TYPE = 'idp-partner-token';
const AMAZON_PARTNER_NAME = 'amazon';
const CANAL_PLUS_PARTNER_NAME = 'canal-plus';
const CONTENT_TYPE_JSON = 'application/json';

function getAuthenticateApiEndPointAddress() {
    const authenticateApiUrl =
        window.dazn.startupData.ServiceDictionary.Authenticate.Versions.v1
            .ServicePath;
    return authenticateApiUrl;
}

function createAuthenticateCallHeaders() {
    const baseHeaders = { 'Content-Type': CONTENT_TYPE_JSON };
    const { isDevModeEnabled } = window.dazn.devMode;

    if (isDevModeEnabled) {
        return {
            ...baseHeaders,
            'x-dazn-marco': '',
            'x-dazn-device': window.dazn.device.guid
        };
    }
    return baseHeaders;
}

function createAuthenticateApiBody(
    partnerApiData: any,
    isAmazonLp: boolean,
    amazonLpClientId: string
) {
    const payload = {
        accessToken: isAmazonLp ? partnerApiData?.accessToken : '',
        clientId: isAmazonLp ? amazonLpClientId : 'dazn_hp',
        providerCustomerId: partnerApiData?.providerCustomerId,
        deviceId: window.dazn.deviceId,
        platform: PLATFORM,
        source: ''
    };

    if (isAmazonLp) {
        payload.source = 'handle-benefits';
    }

    return {
        idpType: IDP_TYPE,
        idpMetadata: {
            version: 1,
            partnerName: isAmazonLp
                ? AMAZON_PARTNER_NAME
                : CANAL_PLUS_PARTNER_NAME
        },
        idpPayload: payload,
        deviceKey: PLATFORM
    };
}

function getAuthenticateReqOptions(partnerApiData: any) {
    const isAmazonLp = checkIsAmazonLP();
    const amazonLpClientId = getAmazonLpClientdId();
    const authenticateApiBody = createAuthenticateApiBody(
        partnerApiData,
        isAmazonLp,
        amazonLpClientId
    );

    const authenticateApiCallOptions = {
        method: 'POST',
        body: JSON.stringify(authenticateApiBody),
        headers: createAuthenticateCallHeaders()
    };

    return authenticateApiCallOptions;
}

export { getAuthenticateReqOptions, getAuthenticateApiEndPointAddress };
